import { useEffect, useState } from 'react'

const NOTIFICATION_KEY = 'hg_notification_shown_at'
const TTL_MS = 24 * 60 * 60 * 1000 // 24 hours
const API_URL = 'https://prodapi.hoaigiangshop.com/rm/landing-page/get-notification'

function shouldShow(): boolean {
  const raw = localStorage.getItem(NOTIFICATION_KEY)
  if (!raw) return true
  return Date.now() - Number(raw) > TTL_MS
}

const PopupNotification = () => {
  const [visible, setVisible] = useState(false)
  const [closing, setClosing] = useState(false)
  const [content, setContent] = useState('')

  useEffect(() => {
    document.body.style.overflow = visible ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [visible])

  useEffect(() => {
    if (typeof window === 'undefined') return
    if (!shouldShow()) return

    const timer = setTimeout(() => {
      fetch(API_URL, { headers: { accept: 'application/json' } })
        .then(r => r.json())
        .then(data => {
          if (data?.data) {
            setContent(data.data)
            setVisible(true)
          }
        })
        .catch(() => {})
    }, 8000)

    return () => clearTimeout(timer)
  }, [])

  const handleClose = () => {
    setClosing(true)
    setTimeout(() => {
      setVisible(false)
      localStorage.setItem(NOTIFICATION_KEY, String(Date.now()))
    }, 350)
  }

  if (!visible) return null

  return (
    <>
      <div
        className={`popup-noti__backdrop${closing ? ' popup-noti__backdrop--out' : ''}`}
        onClick={handleClose}
      />
      <div className={`popup-noti${closing ? ' popup-noti--out' : ''}`}>
        <button className="popup-noti__close" onClick={handleClose} aria-label="Đóng">
          ×
        </button>
        <div
          className="popup-noti__body"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </>
  )
}

export default PopupNotification
